// This function runs ONLY on all non-vuejs tables.
export function initialize() {
  let tables = document.querySelectorAll('table')
  if (!tables) return
  tables.forEach(function(table) {
    let isVueTable = table.dataset.isVue
    if (!isVueTable) {
      handleTable(table)
    }
  })
}

// This function runs ONLY on vuejs tables.
export function initializeForVue() {
  let tables = document.querySelectorAll('table')
  if (!tables) return
  tables.forEach(function(table) {
    let isVueTable = table.dataset.isVue
    if (isVueTable) {
      handleTable(table)
    }
  })
}

function handleTable(table) {
  const tableWidth  = table.querySelector('tbody').offsetWidth
  const parentWidth = table.parentNode.offsetWidth
  if (tableWidth < parentWidth) {
    table.classList.add('fill-parent')
  }
}
